import types from '@/store/types/Usuario'
import Vue from 'vue';
import axios from 'axios'

const state = {
  lstMenus: [],
  lstRepLegales: [],
  BitacoraTotalCorreo: 0,
  oficinaId: 0
}
const getters = {
  [types.getters.GetListaMenus]: (state) => {
    return state.lstMenus;
  },
  [types.getters.GetListaRepLegales]: (state) => {
    return state.lstRepLegales;
  },
  [types.getters.GetOficinaId]: (state) => {
    return state.lstRepLegales;
  }
}
const mutations = {
  [types.mutations.SetListaMenus]: (state, lstMenus) => {
    state.lstMenus = lstMenus;
  },
  [types.mutations.SetRepLegal]: (state, lstRepLegales) => {
    state.lstRepLegales = lstRepLegales;
  },
  [types.mutations.SetBitacoraTotalCorreo]: (state, BitacoraTotalCorreo) => {
    state.BitacoraTotalCorreo = BitacoraTotalCorreo;
  },
  [types.mutations.SetOficinaId]: (state, oficinaId) => {
    state.oficinaId = oficinaId;
  }
}
const actions = {

  [types.actions.Login]: ({ commit }, pObj) => {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_AJAYU}pajel/usuario_empresa/login`, pObj, {
        headers: {
          'application': 'WEB',
          'subsystem': 'PAJEL',
          'module': 'LOGIN'
        }
      })
        .then(r => {
          if (r.status === 200) {
            localStorage.setItem("token", r.data.token)
            resolve(r);
          } else {
            reject(r)
          }
        })
        .catch(error => {
          reject(error);
        });
    })
  },

  [types.actions.RepresentanteLegal]: ({ commit }, pIdPromocion) => {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.get(`pajel/promocion_empresarial/net/representantesLegales/${pIdPromocion}`).then(r => {
        commit(types.mutations.SetRepLegal, r.data);
        resolve(r);
      })
    })
  },


  [types.actions.Cambiar_contrasenia]: ({ commit }, pObj) => {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.put(`pajel/usuario_empresa/cambiar_contrasenia/${pObj.usuarioId}`, pObj).then(r => {
        resolve(r);
      })
    })
  },
  [types.actions.ResetearClave]: ({ commit }, pObj) => {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.put(`pajel/usuario_empresa/resetear_contrasenia`, pObj).then(r => {
        resolve(r);
      })
    })
  },

  [types.actions.Actualizar_correo]: ({ commit }, pObj) => {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.put(`pajel/usuario_empresa/actualizar_correo/${pObj.usuarioId}`, pObj).then(r => {
        resolve(r);
      })
    })
  },
  [types.actions.VerificacionCorreoElectronico]: ({ commit }, pObj) => {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.post(`pajel/usuario_empresa/enviar_solicitud_verificacion/`, pObj).then(r => {
        resolve(r);
      })
    })
  },
  [types.actions.BitacoraCorreoElectronico]: ({ commit }, pObj) => {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.get(`pajel/usuario_empresa/bitacoraCorreos/${pObj.usuarioId}`).then(r => {
        resolve(r);
      })
    })
  },
  [types.actions.BitacoraTotalCorreo]: ({ commit }, pObj) => {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.get(`credencial/solicitud_credencial/existeBitacoraCorreo/${pObj.usuarioId}`).then(r => {
        commit(types.mutations.SetBitacoraTotalCorreo, r.data.resultado.cantidadBitacora);
        resolve(r);
      })
    })
  },
  [types.actions.ReactivarCuenta]: ({ commit }, pObj) => {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.put(`pajel/usuario_empresa/reactivar_cuenta`, pObj).then(r => {
        resolve(r);
      })
    })
  },
  [types.actions.ObtenerListaMenus]: ({ commit }, pMostrar) => {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.get(`pajel/menu_parametrizado/list/${pMostrar}`).then(r => {
        commit(types.mutations.SetListaMenus, r.data);
        resolve(r);
      })
    })
  },
  [types.actions.ObtenerPersona]: ({ commit }, pObj) => {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.get(`pajel/dato_solicitud_documento/net/obtener_persona_usuario_empresa/${pObj.usuarioId}`).then(r => {
        resolve(r);
      })
    })
  },
  [types.actions.ObtenerIdOficina]: ({ commit }, pObj) => {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.get(`pajel/usuario_empresa/obtieneIdOficina/${pObj.dependencia}`).then(r => {
        commit(types.mutations.SetOficinaId, r.data);
        resolve(r);
      })
    })
  },
}
export default {
  state,
  actions,
  getters,
  mutations
}
